export const UserTableHeaders= [ "Name", "Rating", "Delivered", "Requested", "Email", "Mobile", "Address"]
export const userTabOptions = ["Deliveries", "Requests"];
export const tableHeaders = [ "Package Name", "Origin", "Destination ", "Sender Name", "Weight (lbs)", "Expiry Date"];
export const deliveryTabOptions = ["Assigned", "In-Transit","Delivered"];
export const requestorTabOptions = ["Unassigned", "Assigned", "In-Transit","Delivered","Expired"];
